import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validates whether the control's value is a valid email address.
 * The email must match a specific pattern that includes a domain and top-level domain.
 *
 * @param {AbstractControl} control - The form control containing the email value to be validated.
 * @return {ValidationErrors | null} An object with a key 'invalidEmail' if the email is invalid, or null if the email is valid.
 */
export function strictEmailValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;

	// If the field is empty, let 'Validators.required' handle it
	if (!value) {
		return null;
	}

	const emailPattern = /^[^\s@]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
	const isValid = emailPattern.test(value);

	return isValid ? null : { invalidDomain: true };
}
